import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';

import CalendarView from './components/CalendarView';
import WorkingHoursPanel from './components/WorkingHoursPanel';
import DateBlockingPanel from './components/DateBlockingPanel';
import QuickActions from './components/QuickActions';

const PhotographerCalendarManagement = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [workingHours, setWorkingHours] = useState({
    weekday: { start: '09:00', end: '18:00', breakStart: '13:00', breakEnd: '14:00' },
    weekend: { start: '10:00', end: '16:00', breakStart: '', breakEnd: '' }
  });
  const [blockedDates, setBlockedDates] = useState([
    { date: '2026-01-15', reason: 'إجازة شخصية', type: 'personal' },
    { date: '2026-01-20', reason: 'صيانة المعدات', type: 'maintenance' }
  ]);
  const [bookedDates, setBookedDates] = useState([
    { date: '2026-01-18', reference: 'BK-2026-001', client: 'أحمد محمد' },
    { date: '2026-01-25', reference: 'BK-2026-002', client: 'فاطمة علي' }
  ]);

  const handleSaveChanges = () => {
    // Save logic here
    alert('تم حفظ التغييرات بنجاح');
  };

  const handleImportSchedule = () => {
    // Import logic here
    alert('استيراد الجدول');
  };

  const handleExportCalendar = () => {
    // Export logic here
    alert('تصدير التقويم');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white py-8">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-primary shadow-lg">
              <Icon name="Calendar" size={24} className="text-white" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-800 via-blue-700 to-blue-600 bg-clip-text text-transparent">
                إدارة التقويم والجدولة
              </h1>
              <p className="text-slate-600 mt-1">تحكم في أوقات العمل والحجوزات بكل سهولة</p>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <QuickActions 
          onSave={handleSaveChanges}
          onImport={handleImportSchedule}
          onExport={handleExportCalendar}
        />

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
          {/* Calendar View - Takes 2 columns on large screens */}
          <div className="lg:col-span-2">
            <CalendarView 
              selectedDate={selectedDate}
              onDateSelect={setSelectedDate}
              blockedDates={blockedDates}
              bookedDates={bookedDates}
            />
          </div>

          {/* Side Panels */}
          <div className="space-y-6">
            {/* Working Hours Panel */}
            <WorkingHoursPanel 
              workingHours={workingHours}
              onWorkingHoursChange={setWorkingHours}
            />

            {/* Date Blocking Panel */}
            <DateBlockingPanel 
              blockedDates={blockedDates}
              onBlockedDatesChange={setBlockedDates}
            />
          </div>
        </div>

        {/* Statistics Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-8">
          <div className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm hover:shadow-md transition-all duration-300">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-gradient-to-br from-green-500 to-emerald-500">
                <Icon name="CheckCircle" size={24} className="text-white" />
              </div>
              <div>
                <p className="text-2xl font-bold text-slate-900">24</p>
                <p className="text-sm text-slate-600">أيام متاحة</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm hover:shadow-md transition-all duration-300">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-500">
                <Icon name="Calendar" size={24} className="text-white" />
              </div>
              <div>
                <p className="text-2xl font-bold text-slate-900">8</p>
                <p className="text-sm text-slate-600">حجوزات مؤكدة</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm hover:shadow-md transition-all duration-300">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-gradient-to-br from-red-500 to-rose-500">
                <Icon name="XCircle" size={24} className="text-white" />
              </div>
              <div>
                <p className="text-2xl font-bold text-slate-900">3</p>
                <p className="text-sm text-slate-600">أيام محجوبة</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm hover:shadow-md transition-all duration-300">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary">
                <Icon name="Clock" size={24} className="text-white" />
              </div>
              <div>
                <p className="text-2xl font-bold text-slate-900">9-6</p>
                <p className="text-sm text-slate-600">ساعات العمل</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotographerCalendarManagement;